import { EmailTemplateData, Locales } from 'shared-types';

interface Params {
  emailTemplates: EmailTemplateData[];
  language: Locales;
}

/**
 * Get default template from list of email templates data. There can be
 * multiple templates with isDefault true, this means they are the same template
 * but different language versions. Primarily we try to find the default with
 * a matching language, but if we don't we fallback to the default that
 * is not a translation of a custom template
 *
 * @param emailTemplates - list of email templates
 * @param language - desired language
 * @returns A string identifier of the selected default template
 */
const getDefaultEmailTemplate = ({ emailTemplates, language }: Params) => {
  let defaultTemplate: EmailTemplateData | undefined;

  emailTemplates.forEach((template) => {
    if (template.isDefaultTemplate && template.language === language) {
      defaultTemplate = template;
    } else if (
      template.isDefaultTemplate &&
      !template.isCustomTemplateTranslation &&
      !defaultTemplate
    ) {
      defaultTemplate = template;
    }
  });

  return defaultTemplate;
};

export default getDefaultEmailTemplate;
